import ShareIcon from './ShareIcon'

export {ShareIcon}
export default ShareIcon
